import React from "react";

import TableCell from "@app/analytics/components/Table/TableCell";
import SourceIcon from "@app/analytics/MeetingReports/components/SourceIcon";
import Thumbnail from "@app/analytics/MeetingReports/components/Thumbnail";
import type { Report } from "@app/analytics/MeetingReports/types";
import { isTopicReport } from "@app/analytics/MeetingReports/utils";
import * as SessionUtils from "@app/common/utils/sessionUtils";

import { Column } from "@rui/Stack";

const Wrapper = ({
  asCell,
  children,
}: {
  asCell: boolean;
  children: React.ReactNode;
}) => {
  if (asCell) {
    return (
      <TableCell
        align="center"
        sx={{ width: "90px", alignContent: { xxs: "start", sm: "center" } }}
      >
        {children}
      </TableCell>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
};

const SourceCell = ({
  report,
  asCell = true,
}: {
  report: Report;
  asCell?: boolean;
}) => {
  if (isTopicReport(report)) {
    return (
      <Wrapper asCell={asCell}>
        <Column variant="center">
          <SourceIcon size="lg" source={report.provider} />
        </Column>
      </Wrapper>
    );
  }

  return (
    <Wrapper asCell={asCell}>
      <Column variant="center">
        <Thumbnail
          src={report.thumbnailUrl}
          platform={
            SessionUtils.isUploadedSession(report)
              ? "upload"
              : report.meetingPlatform
          }
        />
      </Column>
    </Wrapper>
  );
};

export default SourceCell;
